
import { ISystemContext } from "../Context/SystemContext";
import { MultigameParams3 } from "../MultigameParams3";
import { ImageResource } from "../ResourceManager/ImageResource";
import { Resourceful, Resourceful2 } from "../ResourceManager/Resourceful";
import { ResourceIdentifier } from "../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, LoadingStage, ResourceManager } from "../ResourceManager/ResourceManager";
import { JackpotValuesPause, JackpotValuesReset, JackpotValuesResume, ScreenProtocolScope } from "../ScreenProtocol";
import { SlotGameInitData } from "../SlotGameInitData";
import { Size } from ".././MyHelpers";
import { BigSymbolFreegames3Params, BigSymbolFreegames3 } from "./Bonus/BigSymbolFreegames/BigSymbolFreegames3";
import { BigSymbolSpinAndHold3 } from "./Bonus/BigSymbolSpinAndHold/BigSymbolSpinAndHold3";
import { SlotBonus3 } from "./Bonus/SlotBonus3";
import { SpinAndHold3Params, SpinAndHold3 } from "./Bonus/SpinAndHold/SpinAndHold3";
import { FreegameBonus3Params, FreeGameBonus3 } from "./FreegameBonus/FreegameBonus3";
import { SlotSpinResult, IRunResult } from "./SlotGame";
import { SlotGame3 } from "./SlotGame3";
import { SlotGameMessages } from "./SlotGameScreenMessages";
import { SlotGameState } from "./SlotGameState";
import { StateMachine, StateChange } from "./StateMachine";
import { Settings } from "../Settings";
import { Bonus } from "./Bonus/Bonus";
import { ExtendedSpinAndHold3 } from "./Bonus/ExtendedSpinAndHold/ExtendedSpinAndHold3";
import { ISimpleBonusAction, SimpleSlotGameState } from "../api";

export class SlotGameType1_3 extends SlotGame3 implements Resourceful2 {

	protected view: HTMLElement = null;
	protected viewSize: Size = null;

	protected commonpath: string = null;
	protected basepath: string = null;
	protected jackpot: string = null;

	protected resid: ResourceIdentifier = null;
	protected screenProtocolScope: ScreenProtocolScope = null;
	//crea el contenedor como elemento HTMLElement
	protected jackpotContainer: HTMLElement = null;

	protected stateMachine: StateMachine<SlotGameState> = null;
	protected lastSpinResult: SimpleSlotGameState = null;

	protected bonusList: Map<Bonus, SlotBonus3> = new Map<Bonus, SlotBonus3>();
	protected currentBonus: SlotBonus3 = null;
	protected multigameParams: MultigameParams3 = null;

	protected systemContext: ISystemContext = null;

	public constructor(multigameParams: MultigameParams3, initData: SlotGameInitData) {
		super(initData, multigameParams);

		this.multigameParams = multigameParams;
		this.systemContext = multigameParams.systemContext.CreateSubContext(["SlotGameType1", this.name]);
		this.resid = multigameParams.resid.Add("SlotGameType1").Add(this.name);

		this.screenProtocolScope = new ScreenProtocolScope("SlotGame." + this.name);

		this.stateMachine = new StateMachine<SlotGameState>(SlotGameState.Idle, this.logGroup, (state: SlotGameState) => SlotGameState[state]);

		this.commonpath = Settings.ResourcesFolder + "multigame/slot/common/";
		this.basepath = Settings.ResourcesFolder + "multigame/slot/" + this.name + "/";
		//Ruta de background de los niveles jackpot
		this.jackpot = Settings.ResourcesFolder + "multigame/multigame/img/";

		this.viewSize = multigameParams.viewSize;

		this.view = document.createElement("div");
		this.view.classList.add(this.resid.ID());
		this.view.style.position = "absolute";
		this.view.style.top = "0px";
		this.view.style.left = "0px";
		this.view.style.width = this.viewSize.Width + "px";
		this.view.style.height = this.viewSize.Height + "px";
		this.view.lastChild;


		this.screenProtocol.AddReceiveMessageHandler(
			SlotGameMessages.StateChange.msgname,
			(message) => this.stateMachine.ChangeState((<SlotGameMessages.StateChange<SlotGameState>>message).newState),
			this.screenProtocolScope
		);

		this.screenProtocol.AddReceiveMessageHandler(
			SlotGameMessages.SpinResult.msgname,
			(message) => this.OnSpinResult((<SlotGameMessages.SpinResult>message).spin),
			this.screenProtocolScope
		);

		this.screenProtocol.AddReceiveMessageHandler(
			SlotGameMessages.BonusRunResult.msgname, 
			(message) => this.OnBonusRunResult((<SlotGameMessages.BonusRunResult>message).run), 
			this.screenProtocolScope
		);

		this.screenProtocol.AddReceiveMessageHandler(
			SlotGameMessages.BonusFinished.msgname, 
			(message) => this.OnBonusFinished((<SlotGameMessages.BonusFinished>message)), 
			this.screenProtocolScope
		);
		
		//protocool for resume,reset , pause jackpot update values
		this.screenProtocol.AddReceiveMessageHandler(
			JackpotValuesResume.msgname, (message) => {
				globalThis.jackpotDisplayGlobal?.Resume()
			},
			this.screenProtocolScope);

		this.screenProtocol.AddReceiveMessageHandler(
			JackpotValuesReset.msgname, (message) => {
				globalThis.jackpotDisplayGlobal?.Reset((<JackpotValuesReset>message).jackpotLevel)
			},
			this.screenProtocolScope);

		this.screenProtocol.AddReceiveMessageHandler(
			JackpotValuesPause.msgname, (message) => {
				globalThis.jackpotDisplayGlobal?.Pause()
			},
			this.screenProtocolScope);

        this.stateMachine.SetCallback(SlotGameState.Spin, StateChange.Begin, () => this.OnSpinBegin());
		this.stateMachine.SetCallback(SlotGameState.Bonus, StateChange.Begin, () => this.OnBonusBegin());
		this.stateMachine.SetCallback(SlotGameState.Bonus, StateChange.End, () => this.OnBonusEnd());
	}

	public override async PrepareResources(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager): Promise<void> {

		if (loadingStage != LoadingStage.Games) return;
		await this.BonusesPrepare(loadingStage, resourceManager);
	}

	public override async ResourcesLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void> {
		if (loadingStage != LoadingStage.Games) return;

		await this.BonusesLoaded(loadingStage, resourceManager);
	}

	public async BonusesPrepare(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager): Promise<void> {
		if (this.initData.BonusConfiguration?.FreeGameBonus) {
			await this.FreeGamePrepare(loadingStage, resourceManager);
		}
		if (this.initData.BonusConfiguration?.SpinAndHold) {
			await this.SpinAndHoldPrepare(loadingStage, resourceManager);
		}
		if (this.initData.BonusConfiguration?.BigSymbolSpinAndHold) {
			await this.BigSymbolSpinAndHoldPrepare(loadingStage, resourceManager);
		}
		if (this.initData.BonusConfiguration?.BigSymbolFreegames) {
			await this.BigSymbolFreegamesPrepare(loadingStage, resourceManager);
		}

		// if (this.initData.bonusConfiguration &&
		// 	this.initData.bonusConfiguration["PickBonus"]) 
		// {
		// 	this.PickBonusPrepare(resourceManager);
		// }

		// if (this.initData.bonusConfiguration &&
		// 	this.initData.bonusConfiguration["DiamondSpin"]) 
		// {
		// 	this.DiamondSpinPrepare(resourceManager);
		// }
	}

	public async BonusesLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void> {
		if (this.initData.BonusConfiguration?.FreeGameBonus) {
			await this.FreegamesLoaded(loadingStage, resourceManager);
			// 	/*
			// 	try
			// 	{
			// 		this.freegamebonus.ResourcesLoaded(resourceManager);
			// 		this.bonusesView.appendChild(this.freegamebonus.View());
			// 	}
			// 	catch (ex) {
			// 		debugger;
			// 	}*/
		}
		if (this.initData.BonusConfiguration?.SpinAndHold) {
			await this.SpinAndHoldLoaded(loadingStage, resourceManager);
		}
		if (this.initData.BonusConfiguration?.BigSymbolSpinAndHold) {
			await this.BigSymbolSpinAndHoldLoaded(loadingStage, resourceManager);
		}
		if (this.initData.BonusConfiguration?.BigSymbolFreegames) {
			await this.BigSymbolFreegamesLoaded(loadingStage, resourceManager);
		}
		// if (this.initData.bonusConfiguration &&
		// 	this.initData.bonusConfiguration["PickBonus"]) 
		// {
		// 	this.PickBonusLoaded(resourceManager);
		// }



		// if (this.initData.bonusConfiguration &&
		// 	this.initData.bonusConfiguration.DiamondSpin) 
		// {
		// 	this.DiamondSpinLoaded(resourceManager);
		// }
	}

	protected async FreeGamePrepare(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager) {
		let FreegameBonusParams3: FreegameBonus3Params =
		{
			systemContext: this.systemContext,
			gameName: this.name,
			resid: this.resid,
			logGroup: this.logGroup,
			screenProtocol: this.screenProtocol,
			screenProtocolScope: this.screenProtocolScope,
			gameBonusResourcesBasePath: this.basepath + "resources/FreeGameBonus/",
			commonBonusResourcesBasePath: this.commonpath + "resources/FreeGameBonus/",
			viewSize: this.viewSize,
			bonusConfiguration: this.initData.BonusConfiguration.FreeGameBonus

		};

		let freegameBonus: SlotBonus3 = new FreeGameBonus3(this.resid, FreegameBonusParams3);
		await freegameBonus.PrepareResources(loadingStage, resourceManager);
		this.bonusList.set(Bonus.FreeGameBonus, freegameBonus);
		freegameBonus = null;
		FreegameBonusParams3 = null;

	}

	protected async FreegamesLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager) {
		let freegameBonus = this.bonusList.get(Bonus.FreeGameBonus);
		await freegameBonus.ResourcesLoaded(loadingStage, resourceManager);

		let freegameBonusView = freegameBonus.View();
		freegameBonusView.style.width = this.multigameParams.viewSize.Width + "px";
		freegameBonusView.style.height = this.multigameParams.viewSize.Height + "px";

		this.view.appendChild(freegameBonusView);

		freegameBonus.Hide();
		freegameBonus = null;
		freegameBonusView = null;

	}
	protected async SpinAndHoldPrepare(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager) {

		let sahParam: SpinAndHold3Params =
		{
			systemContext: this.systemContext,
			gameName: this.name,
			resid: this.resid,
			logGroup: this.logGroup,
			screenProtocol: this.screenProtocol,
			screenProtocolScope: this.screenProtocolScope,
			gameBonusResourcesBasePath: this.basepath + "resources/HoldAndSpin/",
			commonBonusResourcesBasePath: this.commonpath + "resources/HoldAndSpin/",
			viewSize: this.viewSize,
			bonusConfiguration: this.initData.BonusConfiguration.SpinAndHold
		};

		let spinAndHold: SlotBonus3 = new ExtendedSpinAndHold3(this.resid, sahParam);
		await spinAndHold.PrepareResources(loadingStage, resourceManager);

		this.bonusList.set(Bonus.SpinAndHold, spinAndHold);
		sahParam = null;
		spinAndHold = null;
	}
	protected async SpinAndHoldLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager) {
		let spinAndHold = this.bonusList.get(Bonus.SpinAndHold);
		await spinAndHold.ResourcesLoaded(loadingStage, resourceManager);

		let spinAndHoldView = spinAndHold.View();
		spinAndHoldView.style.width = this.multigameParams.viewSize.Width + "px";
		spinAndHoldView.style.height = this.multigameParams.viewSize.Height + "px";

		this.view.appendChild(spinAndHoldView);

		spinAndHold.Hide();
		spinAndHold = null;
		spinAndHoldView = null;
	}

	protected async BigSymbolSpinAndHoldPrepare(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager) {
		let sahParam: SpinAndHold3Params =
		{
			systemContext: this.systemContext,
			gameName: this.name,
			resid: this.resid,
			logGroup: this.logGroup,
			screenProtocol: this.screenProtocol,
			screenProtocolScope: this.screenProtocolScope,
			gameBonusResourcesBasePath: this.basepath + "resources/HoldAndSpin/",
			commonBonusResourcesBasePath: this.commonpath + "resources/HoldAndSpin/",
			viewSize: this.viewSize,
			bonusConfiguration: this.initData.BonusConfiguration.BigSymbolSpinAndHold
		};

		let spinAndHold: SlotBonus3 = new BigSymbolSpinAndHold3(this.resid, sahParam);
		await spinAndHold.PrepareResources(loadingStage, resourceManager);

		this.bonusList.set(Bonus.BigSymbolSpinAndHold, spinAndHold);
		sahParam = null;
		spinAndHold = null;		
	}
	protected async BigSymbolSpinAndHoldLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager) {
		let spinAndHold = this.bonusList.get(Bonus.BigSymbolSpinAndHold);
		await spinAndHold.ResourcesLoaded(loadingStage, resourceManager);

		let spinAndHoldView = spinAndHold.View();
		spinAndHoldView.style.width = this.multigameParams.viewSize.Width + "px";
		spinAndHoldView.style.height = this.multigameParams.viewSize.Height + "px";

		this.view.appendChild(spinAndHoldView);

		spinAndHold.Hide();
		spinAndHold = null;
		spinAndHoldView = null;
	}

	//BigFreeGamePrepare
	protected async BigSymbolFreegamesPrepare(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager) {
		let bFGParam: BigSymbolFreegames3Params =
		{
			systemContext: this.systemContext,
			gameName: this.name,
			resid: this.resid,
			logGroup: this.logGroup,
			screenProtocol: this.screenProtocol,
			screenProtocolScope: this.screenProtocolScope,
			gameBonusResourcesBasePath: this.basepath + "resources/BigSymbolFreegames/",
			commonBonusResourcesBasePath: this.commonpath + "resources/BigSymbolFreegames/",
			viewSize: this.viewSize,
			bonusConfiguration: this.initData.BonusConfiguration.BigSymbolFreegames,
		};

		let bigSymbolFG: SlotBonus3 = new BigSymbolFreegames3(this.resid, bFGParam);
		await bigSymbolFG.PrepareResources(loadingStage, resourceManager);

		this.bonusList.set(Bonus.BigSymbolFreegames, bigSymbolFG);
		bigSymbolFG = null;
		bigSymbolFG = null;
	}
	protected async BigSymbolFreegamesLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager) {
		let bigSymbolFG = this.bonusList.get(Bonus.BigSymbolFreegames);
		await bigSymbolFG.ResourcesLoaded(loadingStage, resourceManager);

		let bigSymbolFGdView = bigSymbolFG.View();
		bigSymbolFGdView.style.width = this.multigameParams.viewSize.Width + "px";
		bigSymbolFGdView.style.height = this.multigameParams.viewSize.Height + "px";

		this.view.appendChild(bigSymbolFGdView);

		bigSymbolFG.Hide();
		bigSymbolFG = null;
		bigSymbolFGdView = null;
	}

	
	// protected DiamondSpinPrepare(resourceManager: IWriteOnlyResourceManager) {
	// 	let dsParams: DiamondSpinParams3 =
	// 	{
	// 		systemContext: this.systemContext,
	// 		gameName: this.name,
	// 		resid: this.resid,
	// 		logGroup: this.logGroup,
	// 		screenProtocol: this.screenProtocol,
	// 		screenProtocolScope: this.screenProtocolScope,
	// 		gameResourcesBasePath: this.basepath + "resources/DiamondSpin/",
	// 		commonResourcesBasePath: this.commonpath + "resources/DiamondSpin/",
	// 		viewSize: this.viewSize,
	// 		bonusConfiguration: this.initData.BonusConfiguration.DiamondSpin
	// 	};

	// 	let diamondSpin: SlotBonus3 = new DiamondSpin3(this.resid, dsParams);
	// 	diamondSpin.PrepareResources(resourceManager);

	// 	this.bonusList.set(Bonus.DiamondSpin, diamondSpin);
	// }

	// protected DiamondSpinLoaded(resourceManager: IReadOnlyResourceManager) {
	// 	let diamondSpin = this.bonusList.get(Bonus.DiamondSpin);
	// 	diamondSpin.ResourcesLoaded(resourceManager);

	// 	let diamondSpinView = diamondSpin.View();
	// 	diamondSpinView.style.width = this.multigameParams.viewSize.width + "px";
	// 	diamondSpinView.style.height = this.multigameParams.viewSize.height + "px";

	// 	this.view.appendChild(diamondSpinView);

	// 	diamondSpin.Hide();
	// }


	protected runingBonuses: SlotBonus3[] = [];
	protected OnSpinResult(spinResult: SimpleSlotGameState): void {
		//this.lastSpinResult = spinResult;
		//TODO
		//START
		// if(this.lastSpinResult.Bonus != null)
		// {
		// 	this.currentBonus = this.bonusList.get(this.lastSpinResult.Bonus);
		// 	this.runingBonuses.push(this.currentBonus);
		// }
		//END
	}

	protected OnBonusRunResult(run: ISimpleBonusAction[]):void
	{
		let indexStartConfig = run.findIndex(b => b.Phase == "Start");
		if(run[indexStartConfig].Bonus ){
			let b =this.bonusList.get(run[indexStartConfig].Bonus as Bonus);
			this.runingBonuses.push(b);
			this.currentBonus?.Hide();
			this.currentBonus = this.bonusList.get(run[indexStartConfig].Bonus as Bonus);	
			indexStartConfig = null;		
		}
	}
	
	protected OnBonusFinished(message: SlotGameMessages.BonusFinished)
	{
		if(this.runingBonuses.length !=0)
		{
			this.currentBonus?.Stop();
			this.currentBonus?.Hide();

			this.runingBonuses.pop();
			if(this.runingBonuses.length !=0)
			{
				this.currentBonus = this.runingBonuses[this.runingBonuses.length-1];
				this.currentBonus?.Show();
			}
		}
	}

    protected OnSpinBegin(): void
    {
        // reset
        this.currentBonus = null;
        this.runingBonuses = [];
    }



	protected OnBonusBegin(): void {
		//TODO
		//START
		// if (this.lastSpinResult && this.lastSpinResult.Bonus && this.currentBonus != null) {
		// 	setTimeout(() => {
		// 		this.currentBonus?.Show();
		// 		this.currentBonus?.Start();
		// 	}, 2000);
		// }
		//END
	}

	protected OnBonusEnd(): void {
		if (this.currentBonus) {
			this.currentBonus?.Stop();
			this.currentBonus?.Hide();
		}
	}

	// just returns its own div element
	public View(): HTMLElement {
		return this.view;
	}

	public Recover(): void { }

	public GameSelected(): void {
		this.view.lastChild;
		// this game has been selected
	}

	public GameExit(): void {
		// game has been exited
	}

	// if we need to update any animation...
	public Update(): void {

	}
}
